export var E2EEErrors;
(function (E2EEErrors) {
    E2EEErrors["E2EE_SAS_KEYS_MAC_MISMATCH"] = "e2ee.sas.keys-mac-mismatch";
    E2EEErrors["E2EE_SAS_MAC_MISMATCH"] = "e2ee.sas.mac-mismatch";
    E2EEErrors["E2EE_SAS_MISSING_KEY"] = "e2ee.sas.missing-key";
    E2EEErrors["E2EE_SAS_COMMITMENT_MISMATCHED"] = "e2ee.sas.commitment-mismatched";
    E2EEErrors["E2EE_SAS_CHANNEL_VERIFICATION_FAILED"] = "e2ee.sas.channel-verification-failed";
    E2EEErrors["E2EE_SAS_INVALID_SAS_VERIFICATION"] = "e2ee.sas.invalid-sas-verification";
})(E2EEErrors || (E2EEErrors = {}));
